// Light/dark follows the OS setting. CSS handles the DOM (index.css); this hook is for what CSS can't reach:
// the canvas grid and SVG chart colours. Printing always uses the light theme.
import { useSyncExternalStore } from "react";
import { flushSync } from "react-dom";

const query = typeof window === "undefined" ? null : window.matchMedia("(prefers-color-scheme: dark)");
let printing = false;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((l) => l());

if (typeof window !== "undefined") {
  query?.addEventListener("change", notify);
  // flushSync so charts re-render at print size before the browser lays out the printout.
  window.addEventListener("beforeprint", () => ((printing = true), flushSync(notify)));
  window.addEventListener("afterprint", () => ((printing = false), notify()));
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useDark() {
  return useSyncExternalStore(subscribe, () => !printing && !!query?.matches, () => false);
}

export function usePrinting() {
  return useSyncExternalStore(subscribe, () => printing, () => false);
}

/** Neutral colours for charts and the grid, matching the slate palette in index.css. */
export const NEUTRAL = {
  light: { surface: "#ffffff", sunken: "#f8fafc", hover: "#f1f5f9", grid: "#e2e8f0", axis: "#cbd5e1", marker: "#94a3b8", tick: "#64748b", label: "#334155", text: "#0f172a" },
  dark: { surface: "#151d2e", sunken: "#111827", hover: "#1c2537", grid: "#263044", axis: "#364156", marker: "#56627a", tick: "#9aa5b8", label: "#b6bfcd", text: "#e6eaf0" },
};

export function useNeutral() {
  return NEUTRAL[useDark() ? "dark" : "light"];
}
